import React, { Component } from 'react'
import PropTypes from 'prop-types'

import styles from './ReplacementCarSummary.module.sass'

class ReplacementCarSummary extends Component {
  static propTypes = {
    replacementCar: PropTypes.shape({
      brand: PropTypes.string.isRequired,
      car_model: PropTypes.string.isRequired,
      headline: PropTypes.string.isRequired,
      mileage: PropTypes.string.isRequired,
      images: PropTypes.array.isRequired,
      fuel_type: PropTypes.string.isRequired,
      gear_type: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
    }),
    onEditReplacementCar: PropTypes.func,
    strings: PropTypes.object.isRequired,
    replacementCarSearchAvailable: PropTypes.bool,
  }
  state = {}
  render() {
    const { replacementCar, onEditReplacementCar, strings } = this.props
    return (
      <div className={`${styles.container} car-summary`}>
        <div className={styles.info}>
          <h3 className={styles.infoTitle}>{strings.heading}</h3>
          <div className={styles.carHeadline}>
            {replacementCar.brand} {replacementCar.car_model}{' '}
            <br/>
            {replacementCar.engine_size} {replacementCar.fuel_type}
            <br/>
            {replacementCar.mileage}
            <br/>
            {replacementCar.gear_type}
          </div>
          <div className={styles.infoPrice}>{replacementCar.price}</div>
          {strings.editButton && this.props.replacementCarSearchAvailable && (
            <a
              className={styles.editButton}
              onClick={onEditReplacementCar}
              href="#"
            >
              {strings.editButton}
            </a>
          )}
        </div>
        <div className={styles.image}>
          {replacementCar.images[0] && <img src={replacementCar.images[0]} alt={replacementCar.headline} />}
        </div>
      </div>
    )
  }
}

export default ReplacementCarSummary
